import { API } from "../api/axios";
const END_POINT = "/marks-by-class";
const END_POINT_ADD = "/student-list";
const END_POINT_ADD_FILTER = "/student-mark-filter";
const END_POINT_STORE = "/student-mark";
const END_POINT_FILTER = "/marks-by-class/filter";
const END_POINT_CLASS= "/reports";
class NoteService {
    getAll(params) {
        return API.get(END_POINT, params);
    }
    getFilterNote(params) {
        return API.get(END_POINT_FILTER, params);
    }
    ListStudentNotes(params) {
        return API.get(END_POINT_ADD, params);
    }
    ListStudentNotesFilter(params) {
        return API.get(END_POINT_ADD_FILTER, params);
    }
    create(data) {
        return API.post(END_POINT_STORE, data);
    }
    getFilterClassList(params){
        return API.get(`${END_POINT_CLASS}/class-filter`, params)
    }
    getClassList(params){
        return API.get(`${END_POINT_CLASS}/class-list`, params)
    }
    getDomainList(params){
        return API.get(`${END_POINT_CLASS}/class-field`, params)
    }
    getNotesExamList(id){
        return API.get(`${END_POINT_CLASS}/student-field-mark/${id}`)
    }
    updateNotesExam(id, data){
        return API.post(`${END_POINT_CLASS}/valid-field/${id}`, data)
    }
    getBulletinList(params){
        return API.get(`${END_POINT_CLASS}/class-reports`, params)
    }
    generateBulletinPdf(data){
        return API.post(`${END_POINT_CLASS}/generate-file`, data)
    }
    downloadBulletinPdf(url_name, params) {
        return API.get(`${url_name}`, params)
    }
    communicateToParents(id, data){
        return API.post(`${END_POINT_CLASS}/notification/${id}`, data)
    }
}

export default new NoteService();
